
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { UploadQueueImpl } from '../implementation/UploadQueueImpl';

export class UploadController {
  private uploadImplementation: any;
  private folderUploadImplementation:any;
  private static  singleInstance:UploadController;
  private uploadQueueImpl:any;


  static uploadCtrlRef: any;
  constructor(private globalService, private changeDetectorRef){
    UploadController.uploadCtrlRef = this;
    this.uploadQueueImpl = UploadQueueImpl.getInstance(this.globalService);

  }


  public static getInstance(globalService, cd):UploadController{
    
    if (this.singleInstance == null) {
      this.singleInstance = new UploadController(globalService, cd);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }

  public destroyInstance():void{
    UploadController.singleInstance =null;
    UploadController.uploadCtrlRef?.folderUploadImplementation?.destroyUploadImplementationInstance();
  }

  
  private getImplementationReference(){
    return this.folderUploadImplementation;
  }

  private getUploadArray(){
    return this.uploadQueueImpl;
  }

  private getFolderUploadImplementationReference(){
    return this.folderUploadImplementation;
  }

  public async uploadFiles(files,fileToUpload, uploadParams) {
     AppEvents.emit(EventsList.UPLOAD_STARTED);
    this.uploadQueueImpl.initiateUpload(files,fileToUpload, uploadParams); 

  }

  public cancelUploadRequest(){  
    this.uploadImplementation.cancelAllUploadRequests()
  }

  public folderUploadOnButtonClick(filesAndDirectories, uploadParams){
    AppEvents.emit(EventsList.UPLOAD_STARTED);
    this.uploadQueueImpl.initiateFolderUpload([],filesAndDirectories, uploadParams); 

  }

  public async droppedFilesUpload(filesAndDirectories, files, uploadParams) {
    AppEvents.emit(EventsList.UPLOAD_STARTED);
    this.uploadQueueImpl.initiateDroppableUpload(files,filesAndDirectories, uploadParams); 
    

  }
}




